export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./download.vue?vue&type=template&id=5714c405&"


//////////////////
// WEBPACK FOOTER
// ./src/views/download/download.vue?vue&type=template&id=5714c405&
// module id = null
// module chunks = 